import type { FirstRechargeStagedSnapshot } from "../modules/firstRechargeStaged/types";

/** 充值成功且确有可领取项时写入；回首页后据此自动打开首充分批领取弹窗（与纯登录区分） */
export const SESSION_PENDING_STAGED_FIRST_DEPOSIT_CLAIM =
  "session_pending_staged_first_deposit_claim";

/**
 * 写入 session 后派发（同标签页内 session 变化不会触发 React 更新，需靠此让领取 hook 再跑一轮）。
 * 典型：WebSocket 先回首页再 setItem，或 iframe 成功回调晚于路由切换。
 */
export const FIRST_RECHARGE_STAGED_PENDING_CLAIM_EVENT =
  "first-recharge-staged-pending-claim";

export type PendingStagedClaimGateOptions = {
  /**
   * 须在「本次充值成功、尚未 loadUserInfo」前读取：true 表示用户此前已完成首充，
   * 则不再为「回首页自动弹领取窗」打标（仅首笔存款后的那一次会弹）。
   */
  userAlreadyHadFirstRecharge?: boolean;
};

/** 是否写入 SESSION_PENDING_STAGED_FIRST_DEPOSIT_CLAIM（与两处充值成功路径共用，避免重复散落的 if） */
export function shouldSetPendingStagedClaimAfterDeposit(
  s: FirstRechargeStagedSnapshot | null | undefined,
  opts?: PendingStagedClaimGateOptions
): boolean {
  if (opts?.userAlreadyHadFirstRecharge) return false;
  if (!s) return false;
  if (s.firstDepositMode !== "STAGED_MANUAL") return false;
  if (!s.showStagedUi) return false;
  if ((s.claimableCount ?? 0) > 0) return true;
  return s.stages.some(row => row.status === "CLAIMABLE");
}
